import React, {Fragment, useState, useEffect} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import SearchIcon from '@material-ui/icons/Search';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import SettingsIcon from '@material-ui/icons/Settings';
import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  errorMain: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main
  },
  warningMain: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main
  },
  infoMain: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.main
  },
  successMain: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main
  },
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(0.5)
  },
  cardHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function Receptions(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState({
    idPartner: Boolean(props.user.idPartner) ? props.user.idPartner : '0',
    text: ''
  });
  const [data, setData] = useState({
    partners: [],
    receptions: [],
    lastInteraction: {}
  });
  const [receiveIdReception, setReceiveIdReception] = useState(null);
  const [receiveTemperature, setReceiveTemperature] = useState('');
  const [receiveIdReceptionSL, setReceiveIdReceptionSL] = useState('');
  const [sendIdReception, setSendIdReception] = useState(null);
  const [sendTemperature, setSendTemperature] = useState('');
  const [deleteIdReception, setDeleteIdReception] = useState(null);
  const [showTempOptions, setShowTempOptions] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    ajax('resellerReceptions', {
      idPartner: Boolean(props.user.idPartner) ? props.user.idPartner : filter.idPartner
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setReceiveIdReceptionSL('');
  }, [receiveIdReception]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const filterData = item => true
      && (filter.idPartner === '0' || item.idPartner === filter.idPartner)
      && (
           !!~item.surname.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.name.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.cnp.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.id.toLowerCase().indexOf(filter.text.toLowerCase())
      );

  const renderCardHeaderAvatar = item => {
    if (item.isSent === '0')
      return <ErrorOutlineIcon />;
    else if (item.isReceived === '0')
      return <MailOutlineIcon />;
    else if (item.isValidated === '0')
      return <DoneIcon />;
    else
      return <DoneAllIcon />;
  };

  const renderCardHeaderAction = item => {
    if (item.isSent === '0')
      return (
        <Link to={`/Reception/${item.id}`} className={classes.link}>
          <IconButton color='primary'>
            <EditIcon />
          </IconButton>
        </Link>
      );
    else if (item.isReceived === '0' || item.isValidated === '0')
      return (
        <Link to={`ViewReception/${item.id}`} className={classes.link}>
          <IconButton color='primary'>
            <VisibilityIcon />
          </IconButton>
        </Link>
      );
    else
      return (
        <IconButton color='primary'
          onClick={() => window.open(`${props.url.download}?op=buletin_analize&id_receptie=${item.idReceptionSL}&idResellerReception=${item.id}&SID=${props.user.sessid}&variant=live`)}
        >
          <CloudDownloadIcon />
        </IconButton>
      );
  };

  const renderReceptionState = item => {
    if (item.isSent === '0')
      return <Typography component='span'>Probe neexpediate catre laborator</Typography>;
    else if (item.isReceived === '0')
      return <Typography component='span'>Probe expediate si neprimite de laborator</Typography>;
    else
      return <Typography component='span'>Probe primite si date in lucru la laborator</Typography>;
  };

  const markReceptionAsReceived = () => {
    setIsLoaded(false);
    ajax('resellerMarkReceptionAsReceived', {
      id: receiveIdReception,
      receivedTemperature: receiveTemperature,
      idReceptionSL: receiveIdReceptionSL
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          setData(response.data);
          setReceiveIdReception(null);
        } else
          alert(response.error);

        setIsLoaded(true);
      });
  };

  const markReceptionAsSent = () => {
    setIsLoaded(false);
    ajax('resellerMarkReceptionAsSent', {
      id: sendIdReception,
      sentTemperature: sendTemperature
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          setData(response.data);
          setSendIdReception(null);
        }

        setIsLoaded(true);
      });
  };

  const markReceptionAsDeleted = () => {
    setIsLoaded(false);
    ajax('resellerMarkReceptionAsDeleted', {
      id: deleteIdReception
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          setData(response.data);
          setDeleteIdReception(null);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Recoltari</Typography>
      {Boolean(props.user.idPartner)
        ? <Typography variant='subtitle2'>Sunt afisate toate recoltarile pentru care nu avem rezultatele primite de la laborator.</Typography>
        : <Typography variant='subtitle2'>Sunt afisate toate recoltarile trimise si/sau primite de la parteneri pentru care nu avem buletinul de analize validat.</Typography>
      }
      {Boolean(props.user.idPartner) &&
        <Typography variant='subtitle2'>Pentru a vizualiza lista recoltarilor cu rezultatele primite de la laborator, accesati sectiunea <Link to='/Results'>Rezultate</Link></Typography>
      }
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.receptions.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.receptions.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' select disabled={Boolean(props.user.idPartner)}
              label='Partener'
              placeholder='Partener'
              name='idPartner'
              value={filter.idPartner}
              onChange={handleFilterChange}
            >
              <MenuItem value='0'>Toti partenerii</MenuItem>
              {data.partners.map(partner => (
                <MenuItem key={partner.id} value={partner.id}>
                  {partner.partner}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.receptions.length > 0 && data.receptions.filter(filterData).length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
      }

      {isLoaded &&
        <Grid container spacing={1} alignItems='stretch'>
          {data.receptions.filter(filterData).map(item =>
            <Grid key={item.id} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader}
                  avatar={
                    <Avatar className={Boolean(parseInt(item.isValidated)) ? classes.successMain : Boolean(parseInt(item.isReceived)) ? classes.infoMain : Boolean(parseInt(item.isSent)) ? classes.warningMain : classes.errorMain}>
                      {renderCardHeaderAvatar(item)}
                    </Avatar>
                  }
                  action={renderCardHeaderAction(item)}
                  title={<Typography variant='subtitle2'>{item.surname} {item.name}</Typography>}
                  subheader={<Typography color='textSecondary'>ID recoltare: {item.id}</Typography>}
                />
                <CardContent className={classes.cardContent}>
                  {Boolean(props.user.idPartner)
                    ? <Typography color='textSecondary'>{renderReceptionState(item)}</Typography>
                    : Boolean(item.idReceptionSL)
                      ? <Typography color='primary'>ID receptie SmartLabs: {item.idReceptionSL}</Typography>
                      : <Typography color='secondary'>ID receptie SmartLabs: -</Typography>
                  }
                  {Boolean(props.user.idPartner) && !Boolean(parseInt(item.isSent)) && !Boolean(item.idCompanySL) &&
                    <Typography color='primary'>Pacientul plateste {item.price} RON</Typography>
                  }
                  {Boolean(props.user.idPartner) && !Boolean(parseInt(item.isSent)) && Boolean(item.idCompanySL) &&
                    <Typography color='primary'>Analize decontate de CAS</Typography>
                  }
                  <Divider className={classes.divider} />
                  <Typography component='div' color='textSecondary'>CNP: <Typography color='textPrimary' display='inline'>{item.cnp}</Typography></Typography>
                  <Typography component='div' color='textSecondary'>Telefon: <Typography color='textPrimary' display='inline'>{item.phone}</Typography></Typography>
                  <Typography component='div' color='textSecondary'>Recoltat de: <Typography color='textPrimary' display='inline'>{item.createdBy}</Typography></Typography>
                  <Typography component='div' color='textSecondary'>Recoltat la: <Typography color='textPrimary' display='inline'>{item.createdAt}</Typography></Typography>
                  <Typography component='div' color='secondary'>
                    Rezultatele sunt disponibile
                    <Typography display='inline'>{item.worktime === '0' ? ' in aceeasi zi' : item.worktime === '1' ? ' dupa o zi' : ` dupa ${item.worktime} zile`}</Typography>
                  </Typography>
                  {Boolean(item.description) &&
                    <Fragment>
                      <Divider className={classes.divider} />
                      <Typography component='div' color='textSecondary' style={{whiteSpace: 'pre-wrap'}}>
                        Observatii:
                        <Typography color='textPrimary'>{Boolean(item.description) ? item.description : ''}</Typography>
                      </Typography>
                    </Fragment>
                  }
                  {!Boolean(props.user.idPartner) &&
                    <Fragment>
                      <Divider className={classes.divider} />
                      <Typography variant='caption' color='secondary'>Colaborator extern: {item.companySL}</Typography>
                    </Fragment>
                  }
                </CardContent>
                {Boolean(props.user.idPartner) && !Boolean(parseInt(item.isSent)) &&
                  <CardActions>
                    <Button color='primary' style={{marginLeft: 'auto'}}
                      onClick={() => {
                        setSendIdReception(item.id);
                        setSendTemperature(Math.floor((((new Date() - new Date(data.lastInteraction.sentAt)) % 86400000) % 3600000) / 60000) < 10 ? data.lastInteraction.sentTemperature : '');
                      }}
                    >
                      Trimite probele
                    </Button>
                  </CardActions>
                }
                {!Boolean(props.user.idPartner) && !Boolean(parseInt(item.isReceived)) &&
                  <CardActions>
                    {!Boolean(props.user.idPartner) && !Boolean(parseInt(item.isReceived)) && showTempOptions &&
                      <Button variant='contained' color='secondary' style={{marginRight: 'auto'}}
                        onClick={() => setDeleteIdReception(item.id)}
                      >
                        Sterge
                      </Button>
                    }
                    <Button color='primary' style={{marginLeft: 'auto'}}
                      onClick={() => {
                        setReceiveIdReception(item.id);
                        setReceiveTemperature(item.sentTemperature);
                      }}
                    >
                      Am primit probele
                    </Button>
                  </CardActions>
                }
                {!Boolean(props.user.idPartner) && Boolean(parseInt(item.isReceived)) && !Boolean(parseInt(item.haveResults)) &&
                  <CardActions>
                    <Button variant='contained' color='primary' style={{marginLeft: 'auto'}}
                      onClick={() => window.open(`${props.url.download}?op=etichete&id_receptie=${item.idReceptionSL}&SID=${props.user.sessid}&variant=live`)}
                    >
                      Etichete
                    </Button>
                  </CardActions>
                }
                {Boolean(props.user.idPartner) && Boolean(parseInt(item.haveResults)) &&
                  <CardActions>
                    <Button color='primary' style={{marginLeft: 'auto'}}
                      onClick={() => window.open(`${props.url.download}?op=buletin_analize&id_receptie=${item.idReceptionSL}&SID=${props.user.sessid}&variant=live`)}
                    >
                      Descarca rezultate partiale
                    </Button>
                  </CardActions>
                }
              </Card>
            </Grid>
          )}
        </Grid>
      }

      {isLoaded && !Boolean(props.user.idPartner) && Boolean(data.receptions.length) && !showTempOptions &&
        <Fab variant='extended' className={classes.fab}
          onClick={() => {
            setShowTempOptions(true);
            setTimeout(() => setShowTempOptions(false), 3000);
          }}
        >
          <SettingsIcon className={classes.fabIcon} />
          Optiuni avansate
        </Fab>
      }

      {isLoaded && !!~props.user.permissions.indexOf('partnerAddReception') &&
        <Link to='/AddReception' className={classes.link}>
          <Fab variant='extended' className={classes.fab}>
            <AddIcon className={classes.fabIcon} />
            Adauga recoltare
          </Fab>
        </Link>
      }

      <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
        open={Boolean(parseInt(receiveIdReception))}
        TransitionComponent={Transition}
        onClose={() => setReceiveIdReception(null)}
      >
        <DialogTitle>Marcati aceste probe ca primite de catre laborator?</DialogTitle>
        <DialogContent>
          <DialogContentText component='div'>
            <Typography component='span' display='block' align='justify'>Apasati pe DA doar daca ati primit aceste probe la laborator. Dupa ce marcati probele ca primite se vor deschide automat receptia sau receptiile aferente in aplicatia SmartLabs.</Typography>
            <TextField margin='none' required select
              error={receiveTemperature === ''}
              helperText={receiveTemperature === '' ? 'Selectati temperatura probelor' : ' '}
              label='Temperatura'
              placeholder='Temperatura'
              value={receiveTemperature}
              onChange={e => setReceiveTemperature(e.target.value)}
            >
              <MenuItem key='' value=''>
                Selectati temperatura probelor
              </MenuItem>
              {['4', '5', '6', '7', '8'].map(option => (
                <MenuItem key={option} value={option}>
                  {option}°C
                </MenuItem>
              ))}
            </TextField>
            {data.receptions.filter(reception => reception.id === receiveIdReception).length === 1 && Boolean(data.receptions.filter(reception => reception.id === receiveIdReception)[0].idCompanySL) &&
              <TextField margin='none' required
                error={receiveIdReceptionSL === ''}
                helperText={receiveIdReceptionSL === '' ? 'ID-ul de receptie din SmartLabs se introduce manual' : ' '}
                label='ID receptie SmartLabs'
                placeholder='ID receptie SmartLabs'
                value={receiveIdReceptionSL}
                onChange={e => setReceiveIdReceptionSL(e.target.value)}
              />
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={!isLoaded} onClick={() => setReceiveIdReception(null)}>
            NU
          </Button>
          <Button color='primary'
            disabled={!isLoaded
              || !Boolean(receiveTemperature)
              ||
                (
                     data.receptions.filter(reception => reception.id === receiveIdReception).length === 1
                  && Boolean(data.receptions.filter(reception => reception.id === receiveIdReception)[0].idCompanySL)
                  && !Boolean(receiveIdReceptionSL)
                )
            }
            onClick={markReceptionAsReceived}
          >
            DA
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
        open={Boolean(parseInt(sendIdReception))}
        TransitionComponent={Transition}
        onClose={() => setSendIdReception(null)}
      >
        <DialogTitle>Marcati aceste probe ca trimise catre laborator?</DialogTitle>
        <DialogContent>
          <DialogContentText component='div'>
            <Typography component='span' display='block' align='justify'>Apasati pe DA doar daca ati trimis sau sunteti sigur ca veti trimite aceste probe catre laborator in perioada imediat urmatoare. Dupa ce marcati probele ca trimise catre laborator, nu veti mai avea posibilitatea de a aduce modificari acestei recoltari.</Typography>
            <TextField margin='none' required select
              error={sendTemperature === ''}
              helperText={sendTemperature === '' ? 'Selectati temperatura probelor' : ' '}
              label='Temperatura'
              placeholder='Temperatura'
              value={sendTemperature}
              onChange={e => setSendTemperature(e.target.value)}
            >
              <MenuItem key='' value=''>
                Selectati temperatura probelor
              </MenuItem>
              {['3', '4', '5', '6', '7'].map(option => (
                <MenuItem key={option} value={option}>
                  {option}°C
                </MenuItem>
              ))}
            </TextField>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={!isLoaded} onClick={() => setSendIdReception(null)}>
            NU
          </Button>
          <Button disabled={!isLoaded || !Boolean(sendTemperature)} onClick={markReceptionAsSent} color='primary'>
            DA
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
        open={Boolean(parseInt(deleteIdReception))}
        TransitionComponent={Transition}
        onClose={() => setDeleteIdReception(null)}
      >
        <DialogTitle>Marcati aceste probe ca sterse?</DialogTitle>
        <DialogContent>
          <DialogContentText><Typography component='span' display='block' align='justify'>Apasati pe DA doar daca sunteti sigur ca doriti sa stergeti aceasta recoltare. Dupa stergere nu veti mai avea acces la aceasta recoltare. Atentie, se va sterge si receptia deschisa in SmartLabs asociata acestei recoltari, daca aceasta exista.</Typography></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={!isLoaded} onClick={() => setDeleteIdReception(null)}>
            NU
          </Button>
          <Button disabled={!isLoaded} onClick={markReceptionAsDeleted} color='secondary'>
            DA
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}